import { createFileRoute } from "@tanstack/react-router";
import { OutlineReviewPage } from "@client/components/doc-generation/outline-review-page";

export const Route = createFileRoute("/_app/doc-generation/$taskId/outline")({
  component: OutlineReview,
});

function OutlineReview() {
  const { taskId } = Route.useParams();
  return <OutlineReviewPage taskId={taskId} />;
}
